import { createFileRoute, redirect } from '@tanstack/react-router'

// import { RootRoute } from '@/pages/auth/route-entries/login'
import { OAuthMigrationRoute } from '@/pages/auth/route-entries/oauth-migration'
import { authQuery, defaultAuthQuery } from '@/pages/auth/search-schema'
import { store } from '@/store'
import { buildOAuthRedirectUrl, getBackUrl } from '@/utils/helpers'

export const Route = createFileRoute('/_auth/login/')({
  // TODO: left the commented email login ability for email login for dev purposes if needed
  // component: RootRoute,
  component: OAuthMigrationRoute,
  validateSearch: (search) => authQuery.catch(defaultAuthQuery).parse(search),
  beforeLoad: ({ search }) => {
    const state = store.getState()

    if (!state.isInitialized) {
      return null
    }

    if (state.isAuthorized) {
      throw redirect({
        to: getBackUrl(search.back_url),
      })
    } else {
      if (
        (search.type === 'oauth' && (search.code === undefined || search.code.length === 0)) ||
        !search.type
      ) {
        window.location.href = buildOAuthRedirectUrl(search.back_url)

        return null
      }
    }
  },
})
